import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import PerfilAcessoForm from '../components/perfilAcesso/PerfilAcessoForm';

const PerfilAcessoEditar: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box sx={{ mb: 4 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/perfis-acesso')}
          sx={{ mb: 2 }}
        >
          Voltar
        </Button>
        <Typography variant="h4" component="h1">
          Editar Perfil de Acesso
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
          Altere as informações do perfil de acesso
        </Typography>
      </Box>
      
      <PerfilAcessoForm />
    </Container>
  );
};

export default PerfilAcessoEditar;
